export const CONTACT_QUERY_KEYS = {
  default: () => ['contact'] as const,
  submit: () => [...CONTACT_QUERY_KEYS.default(), 'submit'] as const,
};
